import axios from 'axios'
import router from '../router/index'
import { Message } from "element-ui";


// const baseURL = process.env.VUE_APP_BASE_URL
const baseURL = "https://scholary.newacademic.net/"
// const baseURL = window.location.origin +"/"
//封装axios
const request = axios.create({
    baseURL,
    timeout:100*1000
})


// 添加请求拦截器
request.interceptors.request.use(function (config) {
    if(localStorage.getItem('token')){
        config.headers.common = {
            token:localStorage.getItem('token').replace(/^\"|\"$/g,'')
        }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

// 添加响应拦截器
request.interceptors.response.use(function (response) {
    if(response.data.token_code === 400){
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('organ_name')
        window.localStorage.removeItem('role')
        router.push({
            name:"Login"
        })
        Message({
            type:'error',
            message:"登录失效，请重新登录"
        })
    }
    return response;
  }, function (error) {
 
    return Promise.reject(error);
  });

router.beforeEach((to, from, next) => {
    if (to.path !== '/index' && to.path !== '/login' && !window.localStorage.getItem("token")) {
      // 用户未登录跳转到登录页面
      return next('/login')
    } else {
      next()
    }
  })

  export default request